import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Card,
    Collapse,
    Form,
    Modal,
    OverlayTrigger,
    Table,
    Tooltip,
} from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroller";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "../serviceRequests/serviceRequests.scss";
import avatar1 from "../../images/avatar/1.jpg";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteCallHistory } from "../../service/api/callHistory/deleteSingleDetails";
import { ticketCallRequest } from "../../service/api/ticket/ticketCallRequest";

import { bulkCallDelete } from "../../service/api/callHistory/bulkCallDelete";
import DummyBackdropLoader from "../../component/backDrop/dummyBackDropLoader";
import ErrorBackdropLoader from "../../component/backDrop/errorBackDropLoader";
import BackDropLoaderWithoutUpdate from "../../component/backDrop/backDropLoaderWithoutUpdate";
import BackDrop from "../../component/backDrop/backDropLoader";
import UpdateServiceRequest from "../../component/updateServiceRequest/updateServiceRequest";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import TextArea from "../../jsx/components/fields/textArea";
import { BsStarFill } from "react-icons/bs";
import { BiStar } from "react-icons/bi";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import {
    lblEnterProblemDescription,
    txtCategory,
    txtCreatedBy,
    txtDateTime,
    txtServiceID,
    txtServiceRequests,
    txtStatus,
} from "../../dataBaseFile/label";
import {
    btnAvailableServices,
    btnMyServices,
    btnOpenJobs,
} from "../../dataBaseFile/alert";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { validEmail_OR_MobileNumberText } from "../../dataBaseFile/error";
import {
    emailValidation,
    noSpaceOnChange,
    phoneValidation,
} from "../../functions/validations";
import shareServiceRequest from "../../service/api/ticket/shareServiceRequest";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import {
    setMyCurrentTab,
    setMyCurrentTabRedux,
} from "../../feature/serviceRequest/serviceRequestRedux";
import { getCounterApi } from "../../service/api/ticket/serviceCounters";
import { setCurrentPage } from "../../feature/userData/userData";
import { getUserRating } from "../../service/api/user/getUserRating";
import CustomTable from "../../jsx/components/customTable/customTable";
const ReviewsRatings = () => {
    const { role, permissionArr, avgRatingFloat } = useSelector((state) => state.user);
    const { myCurrentTab } = useSelector((state) => state.service);

    const permissionArray = permissionArr[0] || [];
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [elements, setElements] = useState([]);
    const [inProgressElements, setInProgressElements] = useState([]);
    const [completedElements, setCompletedElemets] = useState([]);
    const [cancelledElements, setCancelledElements] = useState([]);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);

    const [renderTicketListPro, setRenderTicketListPro] = useState(1);
    const [flag, setFlag] = useState(false);

    const [ticketID, setTicketID] = useState(null);
    const [counters, setCounters] = useState({});

    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);
    const [callLogIdIds, setCallLogIdIds] = useState(null);
    const [userCallLogIdIds, setUserCallLogIdIds] = useState(null);
    const [showCallDetails, setShowCallDetails] = useState(false);
    const [sentRequest, setSentRequest] = useState([]);
    const [flagForTicket, setFlagForTicket] = useState(true);
    const [showShareServiceModal, setShowShareServiceModal] = useState(false);
    const handleShowShareServiceModal = () => setShowShareServiceModal(true);
    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState();
    const [isPhone, setIsPhone] = useState(false);
    const [shareLoading, setShareLoading] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState("");
    const [handleToaster, setHandleToaster] = useState(false);

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);


    useEffect(() => {
        setPage(1);
        setElements([]);
        // onLoadData();
    }, [myCurrentTab, searchValue]);


    const handleChangeRowsPerPage = (e) => {
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };

    const getCallHistoryDetails = (res) => {
        // console.log(res, "Res")

        const newElements = [...elements, ...res.data];
        const uniqueElements = Array.from(
            new Set(newElements.map(JSON.stringify))
        ).map(JSON.parse);
        setElements(uniqueElements);
        setTotalNoRecord(res.total_count);
        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }

        if (res.total_count === 0) {
            setTimeout(() => {
                setSkeltonVal(true);
            }, "3000");
        } else {
            setSkeltonVal(true);
        }
        // console.log(parseInt(res.total_records / pageSize), 'quoitent')
    };

    const [isMore, setIsMore] = useState(true);
    const onLoadData = () => {
        setCustomeSkeletonLoading(true);
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        setIsMore(false);
        dispatch(
            getUserRating(data, (res) => {
                if (res.data?.length !== 0) {
                    setIsMore(true);
                }
                getCallHistoryDetails(res);
                setCustomeSkeletonLoading(false);
            })
        );

        return;
    };

    const onChangePage = (e, p) => {
        // setPage(p)
        handleToggle(null);
        setPage(e);
    };

    const handleSearch = (e) => {
        // setPage(1)
        setPage(1);
        const ele = []
        setElements(ele);

        handleToggle(null);
        if (searchValue.trim().length >= 2) {
            onChangePage(1);
            setColumnName("");
        }
        setSearchValue(e.target.value);
    };

    const handleCheckbox = (e, i) => {
        const array = [...bulkDeleteArr];
        if (array.includes(e.user_call_log_id_ids)) {
            var index = array.indexOf(e.user_call_log_id_ids);
            array.splice(index, 1);
            setBulkDeleteArr(array);
        } else {
            array.push(e.user_call_log_id_ids);
            setBulkDeleteArr(array);
        }
    };
 

    useEffect(() => {

        onLoadData();
    }, [
        sortByValue,
        pageSize,
        columnName,
        renderTicketListPro,
        myCurrentTab,
        filtreValue,
        page,
    ]);

    function onLoadSearch() {
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(getUserRating(data, (res) => getCallHistoryDetails(res)));
    }

    useEffect(() => {
        if (searchValue.trim().length > 2) {

            const ele = [];
            setPage(1);
            setElements(ele);
            setFlag(true);
            const timeOutId = setTimeout(() => {
                    onLoadSearch();
                }, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);


    // With new logic
    const [expandedRow, setExpandedRow] = useState(null);

    const handleToggle = (rowIndex) => {
        if (rowIndex === expandedRow) {
            setExpandedRow(null);
        } else {
            setExpandedRow(rowIndex);
        }
    };

    const isRowExpanded = (rowIndex) => {
        return rowIndex === expandedRow;
    };

    // Modal triggers for the service requests details
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        onLoadData();
    };
    const handleShow = (e) => {
        localStorage.setItem("ticket_id", e?.ticket_id_ids);
        localStorage.setItem("ticket_display_name", e?.display_id_int);
        setTicketID(e.ticket_id_ids);
        setShow(true);
        navigate("/serviceRequestDetails");
        // navigate("/serviceRequestDetailsCopy");
    };

    // Modal triggers for the call details

    const handleCloseCallDetails = () => {
        setShowCallDetails(false);
        // ticketStatus(particularTicketID)
    };
    const handleShowCallDetails = (element) => {
        setCallLogIdIds(element.call_log_id_ids);
        setUserCallLogIdIds(element.user_call_log_id_ids);
        setShowCallDetails(true);
        navigate("/callDetails");
    };


    // Share Service Request functions start here ---------

    const handleCloseShareServiceModal = () => {
        setShowShareServiceModal(false);
        setEmailPhoneValue("");
        setCodeValue();
        setIsEmailPhoneVal(false);
    };

    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setElements(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    const scrollContainerRef = useRef(null);
    // Share Service Request functions ends here ---------
    const [isAtBottom, setIsAtBottom] = useState(false);
    const checkScroll = (event) => {
        const scrollDiv = scrollContainerRef.current;
        if (scrollDiv) {
            const isAtBottom =
                scrollDiv.scrollHeight - scrollDiv.scrollTop === scrollDiv.clientHeight;
            const isScrollingUp = scrollDiv.scrollTop < scrollDiv.lastScrollTop;

            // Trigger alert only when scrolling down and at the bottom
            if (isAtBottom) {
                setPage(page + 1);
            }

            // Store current scroll position for the next check
        }
    };

    function loadMoreFn(e) {
        localStorage.setItem("page", e);
    }



    return (
        <div className="row mx-0 w-100">
            <div className="col-12 align-items-center">

                {/* Reviews and Ratings headings */}
                <div
                    className="row border-bottom"
                >
                    <div
                        className="row mx-0 my-2 align-items-center"
                    >
                        <div className="col-md-6 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center fs-5">
                                    <div className="ps-4 text-black">
                                        <span>{"Reviews:"}</span>
                                        <span className="ps-1 fw-bold">{totalNoRecord}</span>
                                    </div>

                                    <div className="ps-4 text-black">
                                        <span>{"Ratings:"}</span>
                                        <span className="ps-1 fw-bold">
                                            {avgRatingFloat?.toFixed(2)}
                                            <i class="bi bi-star-fill ps-2"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 px-0">
                            <div className="row">
                                <span className="fs-6 p-2 d-flex align-items-center justify-content-end">
                                    <span
                                        className="fs-6 p-2 d-flex align-items-center"
                                        style={{
                                            border: "1px solid lightgray",
                                            borderRadius: "4px",
                                        }}>
                                        <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                        <input
                                            placeholder="Search"
                                            style={{ border: "0px", width: "100%" }}
                                            onChange={handleSearch}
                                            value={searchValue}
                                        />
                                    </span>
                                    <span className="fs-5 p-2 d-flex align-items-center">
                                        <LuArrowUpDown
                                            className="pointer"
                                            style={{ marginRight: "4px", color: "black" }}
                                            onClick={handleOpenFiltreBox}
                                        />
                                        <span
                                            className="fs-6  pointer"
                                            style={{ position: "relative" }}
                                            onClick={handleOpenFiltreBox}>
                                            {filtreValue == 1 && "Date: Newset first"}
                                            {filtreValue == 2 && "Date: Oldest first"}
                                            {/* {filtreValue == 3 && " Price: Highest first"}
                                            {filtreValue == 4 && "Price: Lowest first"}{" "} */}
                                            &nbsp;
                                            {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                            <span
                                                className={`${filtreBox ? "" : "d-none"} p-3`}
                                                style={{
                                                    position: "absolute",
                                                    top: "26px",
                                                    width: "152px",

                                                    border: "1px solid lightgray",
                                                    background: "white",
                                                    right: "0",
                                                    boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                }}>
                                                <div className="row">
                                                    <div
                                                        className={`${filtreValue == 1 ? "dt" : ""
                                                            } d-flex justify-content-start m-1 pointer `}
                                                        onClick={() => {
                                                            handleSetFiltreValue(1);
                                                        }}>
                                                        Date: Newest first
                                                    </div>
                                                    <div
                                                        className={`${filtreValue == 2 ? "dt" : ""
                                                            } d-flex justify-content-start m-1 pointer`}
                                                        onClick={() => {
                                                            handleSetFiltreValue(2);
                                                        }}>
                                                        Date: Oldest first
                                                    </div>
                                                </div>
                                            </span>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                <div className="">
                    <CustomTable elements={elements} tableType={2} />


                    {customeSkeletonLoading
                        ? (elements)?.length > 0 &&
                        totalNoRecord > (elements)?.length && (
                            <div className="text-center pointer my-2">Loading ...</div>
                        )
                        : (elements)?.length > 0 &&
                        totalNoRecord > (elements)?.length && (
                            <div
                                className="text-center pointer my-2"
                                onClick={() => {
                                    setPage(page + 1);
                                }}>
                                click to view more
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default ReviewsRatings;
